/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Divider,
  InputAdornment,
  Link,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

import { getStorage } from '../../utils/functions/localstorage';
import Loading from '../../components/Loading';
import inetlogo from '../../assets/images/inetlogo.png';
import { PassportAuth } from '../../contexts/AuthContext';

function LoginAdminEEntry() {
  const { handleAdminSigninEEntry } = useContext(PassportAuth);
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const expired = localStorage.getItem('sessionExpired');

    if (expired) {
      localStorage.removeItem('sessionExpired');

      Swal.fire({
        icon: 'warning',
        title: 'หมดเวลาใช้งาน',
        text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
        confirmButtonText: 'ตกลง',
        allowOutsideClick: false,
      });
    }
  }, []);

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await handleAdminSigninEEntry(data.email, data.password);
      navigate('/');
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'เข้าสู่ระบบไม่สำเร็จ',
        text: 'กรุณาตรวจสอบ Email หรือ Password อีกครั้ง',
        confirmButtonText: 'ตกลง',
      });

      setIsLoading(false);
    }
  };

  const inputStyle = {
    '& .MuiInputLabel-root': {
      color: '#64748B',
      fontSize: { xs: 14, sm: 16 },
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 3,
      bgcolor: '#F8FAFC',
      minHeight: { xs: 54, sm: 56 },
      '& fieldset': {
        borderColor: '#E2E8F0',
      },
      '&:hover fieldset': {
        borderColor: '#CBD5E1',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#2563EB',
        borderWidth: 1,
      },
    },
    '& .MuiInputBase-input': {
      fontSize: { xs: 14, sm: 15 },
    },
  };

  return getStorage('token') ? (
    <Navigate to="/" />
  ) : (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        bgcolor: '#F8FAFC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 3 },
        py: { xs: 3, md: 4 },
        background: `
          radial-gradient(circle at 15% 20%, rgba(37, 99, 235, 0.28), transparent 28%),
          radial-gradient(circle at 85% 80%, rgba(236, 72, 153, 0.22), transparent 30%),
          radial-gradient(circle at 80% 10%, rgba(14, 165, 233, 0.20), transparent 26%),
          linear-gradient(135deg, #F8FAFC 0%, #EEF4FF 50%, #FFF7FB 100%)
        `,
      }}
    >
      <CssBaseline />
      <Loading isLoading={isLoading} />

      <Container
        maxWidth="md"
        disableGutters
        sx={{
          width: '100%',
          maxWidth: { xs: 420, md: 900 },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            minHeight: { xs: 'auto', md: 560 },
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '0.9fr 1.1fr' },
            borderRadius: { xs: 4, md: 6 },
            overflow: 'hidden',
            bgcolor: {
              xs: 'rgba(255, 255, 255, 0.94)',
              md: 'rgba(255, 255, 255, 0.78)',
            },
            border: '1px solid rgba(255, 255, 255, 0.75)',
            backdropFilter: 'blur(24px)',
            boxShadow: {
              xs: '0 20px 60px rgba(15, 23, 42, 0.12)',
              md: '0 30px 100px rgba(15, 23, 42, 0.14)',
            },
          }}
        >
          {/* Desktop Brand Panel */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              position: 'relative',
              flexDirection: 'column',
              justifyContent: 'space-between',
              p: 5,
              color: '#FFFFFF',
              overflow: 'hidden',
              background: `
                radial-gradient(circle at 20% 20%, rgba(255,255,255,0.25), transparent 26%),
                radial-gradient(circle at 80% 75%, rgba(255,255,255,0.18), transparent 30%),
                linear-gradient(145deg, #0F4898 0%, #2563EB 52%, #38BDF8 100%)
              `,
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                width: 220,
                height: 220,
                borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.14)',
                top: -70,
                right: -80,
              }}
            />

            <Box
              sx={{
                position: 'absolute',
                width: 170,
                height: 170,
                borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.12)',
                bottom: -50,
                left: -40,
              }}
            />

            <Stack spacing={2} sx={{ position: 'relative', zIndex: 1 }}>
              <Box
                component="img"
                src={inetlogo}
                alt="INET Logo"
                sx={{
                  width: 96,
                  height: 'auto',
                  filter: 'brightness(0) invert(1)',
                }}
              />

              <Typography
                sx={{
                  fontSize: 34,
                  fontWeight: 800,
                  lineHeight: 1.15,
                  letterSpacing: '-0.04em',
                }}
              >
                INET
                <br />E - Entry Admin
              </Typography>

              <Typography
                sx={{
                  maxWidth: 280,
                  fontSize: 15,
                  lineHeight: 1.8,
                  color: 'rgba(255,255,255,0.82)',
                }}
              >
                Administrator access portal.
              </Typography>
            </Stack>

            {/* <Box
              sx={{
                position: 'relative',
                zIndex: 1,
                p: 2.5,
                borderRadius: 4,
                bgcolor: 'rgba(255,255,255,0.14)',
                border: '1px solid rgba(255,255,255,0.18)',
                backdropFilter: 'blur(14px)',
              }}
            >
              <Typography
                sx={{
                  fontSize: 13,
                  color: 'rgba(255,255,255,0.75)',
                }}
              >
                System
              </Typography>

              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 700,
                }}
              >
                Admin Authentication
              </Typography>
            </Box> */}
          </Box>

          {/* Mobile Brand Header */}
          <Box
            sx={{
              display: { xs: 'block', md: 'none' },
              p: 2,
              pb: 0,
            }}
          >
            <Box
              sx={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 4,
                p: 3,
                color: '#FFFFFF',
                background: `
                  radial-gradient(circle at 15% 20%, rgba(255,255,255,0.28), transparent 28%),
                  radial-gradient(circle at 90% 80%, rgba(255,255,255,0.18), transparent 30%),
                  linear-gradient(135deg, #0F4898 0%, #2563EB 55%, #38BDF8 100%)
                `,
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  width: 130,
                  height: 130,
                  borderRadius: '50%',
                  bgcolor: 'rgba(255,255,255,0.14)',
                  top: -45,
                  right: -35,
                }}
              />

              <Box
                sx={{
                  position: 'absolute',
                  width: 90,
                  height: 90,
                  borderRadius: '50%',
                  bgcolor: 'rgba(255,255,255,0.10)',
                  bottom: -30,
                  left: -20,
                }}
              />

              <Stack
                spacing={1.5}
                sx={{
                  position: 'center',
                  zIndex: 1,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Box
                  component="img"
                  src={inetlogo}
                  alt="INET Logo"
                  sx={{
                    width: 78,
                    height: 'auto',
                    filter: 'brightness(0) invert(1)',
                  }}
                />

                <Box>
                  <Typography
                    sx={{
                      fontSize: 26,
                      fontWeight: 900,
                      lineHeight: 1.1,
                      letterSpacing: '-0.04em',
                    }}
                  >
                    INET E - Entry
                  </Typography>

                  {/* <Typography
                    sx={{
                      mt: 0.75,
                      fontSize: 13,
                      color: 'rgba(255,255,255,0.82)',
                    }}
                  >
                    Administrator access portal
                  </Typography> */}
                </Box>
                {/* 
                <Box
                  sx={{
                    width: 'fit-content',
                    px: 1.5,
                    py: 0.75,
                    borderRadius: 999,
                    bgcolor: 'rgba(255,255,255,0.16)',
                    border: '1px solid rgba(255,255,255,0.18)',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: 'rgba(255,255,255,0.92)',
                    }}
                  >
                    Admin Authentication
                  </Typography>
                </Box> */}
              </Stack>
            </Box>
          </Box>

          {/* Login Form */}
          <Box
            sx={{
              px: { xs: 2.5, sm: 5, md: 6 },
              py: { xs: 3, sm: 5, md: 6 },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Stack
              spacing={1}
              alignItems={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mb: { xs: 3, md: 4 },
              }}
            >
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: 24, sm: 32 },
                  fontWeight: 800,
                  color: '#0F172A',
                  letterSpacing: '-0.04em',
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Admin Sign in
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: 14, sm: 15 },
                  color: '#64748B',
                  textAlign: { xs: 'center', md: 'left' },
                  maxWidth: { xs: 300, md: 'none' },
                }}
              >
                Enter your administrator account to continue.
              </Typography>
            </Stack>

            <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={{ xs: 2, sm: 2.25 }}>
                <TextField
                  fullWidth
                  required
                  id="email"
                  label="Email Address"
                  type="email"
                  autoComplete="email"
                  autoFocus
                  {...register('email')}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonOutlineIcon sx={{ color: '#94A3B8' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={inputStyle}
                />

                <TextField
                  fullWidth
                  required
                  id="password"
                  label="Password"
                  type="password"
                  autoComplete="current-password"
                  {...register('password')}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon sx={{ color: '#94A3B8' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={inputStyle}
                />

                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  disabled={isLoading}
                  endIcon={!isLoading && <ArrowForwardIcon />}
                  sx={{
                    mt: 1,
                    py: { xs: 1.35, sm: 1.45 },
                    borderRadius: 3,
                    bgcolor: '#0F172A',
                    color: '#FFFFFF',
                    fontSize: 15,
                    fontWeight: 800,
                    textTransform: 'none',
                    boxShadow: '0 14px 30px rgba(15, 23, 42, 0.18)',
                    '&:hover': {
                      bgcolor: '#1E293B',
                      boxShadow: '0 18px 36px rgba(15, 23, 42, 0.22)',
                    },
                    '&.Mui-disabled': {
                      bgcolor: '#94A3B8',
                      color: '#FFFFFF',
                    },
                  }}
                >
                  {isLoading ? 'Signing in...' : 'Login as Admin'}
                </Button>
              </Stack>
            </Box>

            <Divider
              sx={{
                my: 3,
                display: { xs: 'none', sm: 'flex' },
              }}
            >
              <Typography sx={{ fontSize: 12, color: '#94A3B8' }}>
                OR
              </Typography>
            </Divider>

            <Stack
              spacing={1.25}
              alignItems="center"
              sx={{
                mt: { xs: 2.5, sm: 0 },
              }}
            >
              <Link
                href="https://one.th/type_forgot_password"
                underline="hover"
                sx={{
                  fontSize: 14,
                  color: '#64748B',
                  fontWeight: 600,
                }}
              >
                Forgot password?
              </Link>

              <Typography
                sx={{
                  fontSize: 14,
                  color: '#64748B',
                  textAlign: 'center',
                }}
              >
                Don&apos;t have an account?{' '}
                <Link
                  href="https://one.th/register"
                  underline="hover"
                  sx={{
                    color: '#2563EB',
                    fontWeight: 800,
                  }}
                >
                  Sign Up
                </Link>
              </Typography>
            </Stack>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default LoginAdminEEntry;
